'use strict';

angular.module('paizacloudApp')
  .factory('Language', function() {

    let Language, i, langinfos, language, languageId2LavelMap, languages, len;

    langinfos = {
      'c': [
        "#include <stdio.h>\nint main(void){\n",
        "    // ",
        "    ",
        "}\n",
        "c_cpp",
        "Main.c",
      ],
      'cpp': [
        "#include <iostream>\nusing namespace std;\nint main(void){\n",
        "    // ",
        "    ",
        "}\n",
        "c_cpp",
        "Main.cpp",
      ],
      'objective-c': [
        "#import <Foundation/Foundation.h>\nint main(void){\n    NSAutoreleasePool* pool = [[NSAutoreleasePool alloc] init];\n",
        "    // ",
        "    ",
        "    NSString *s = @\"XXXXXXXX\";\n    [[NSFileHandle fileHandleWithStandardOutput] writeData: [s dataUsingEncoding: NSUTF8StringEncoding]];\n    [pool release];\n    return 0;\n}",
        "objectivec",
        "Main.m",
      ],
      'java': [
        "import java.io.BufferedReader;\nimport java.io.InputStreamReader;\n\npublic class Main {\n    public static void main(String[] args) throws Exception {\n",
        "        // ",
        "        BufferedReader br = new BufferedReader(new InputStreamReader(System.in));\n        String line = br.readLine();",
        "    }\n}\n",
        "java",
        "Main.java",
      ],
      'scala': [
        "object Main extends App{\n",
        "    // ",
        "    ",
        "    println(\"XXXXXXXX\")\n}\n",
        "scala",
        "Main.scala",
      ],
      'csharp': [
        "public class Hello{\n    public static void Main(){\n",
        "        // ",
        "        ",
        "        System.Console.WriteLine(\"Hello C#\");\n    }\n}\n",
        "csharp",
        "Main.cs",
      ],
      'fsharp': [
        "",
        "// ",
        "",
        "",
        "text",
        "Main.fs",
      ],
      'go': [
        "package main\nimport \"fmt\"\nfunc main(){\n",
        "    // ",
        "    ",
        "    fmt.Println(\"XXXXXXXX\")\n}\n",
        "golang",
        "Main.go",
      ],
      'haskell': [
        "",
        "-- ",
        "",
        "main = putStrLn \"XXXXXXXX\"",
        "haskell",
        "Main.hs",
      ],
      'clojure': [
        "",
        "; ",
        "",
        "(println \"XXXXXXXX\")",
        "clojure",
        "Main.clj",
      ],
      'd': [
        "",
        "// ",
        "",
        "import std.stdio;\nvoid main(){\n  writeln(\"XXXXXXXX\");\n}",
        "d",
        "Main.d",
      ],
      'erlang': [
        "-module(main).\n-export([main/1]).\n",
        "%% ",
        "",
        "main([_]) ->\n    io:format(\"XXXXXXXX\"),\ninit:stop() .\n",
        "erlang",
        "main.erl",
      ],
      'cobol': [
        "IDENTIFICATION DIVISION.\nprogram-id. Hello.\nprocedure division.\n",
        "# ",
        "",
        "display \"XXXXXXXX\".\n",
        "cobol",
        "Main.cob",
      ],
      'vb': [
        "public class compiler\n  shared function Main as integer\n",
        "' ",
        "    ",
        "    Console.WriteLine (\"XXXXXXXX\")\n    return 0\n  End function\nend class\n",
        "vbscript",
        "Main.vb",
      ],
      'perl': [
        "",
        "# ",
        "",
        "",
        "perl",
        "Main.pl",
      ],
      'python': [
        "# coding: utf-8\n",
        "# ",
        "",
        "",
        "python",
        "Main.py",
      ],
      'python3': [
        "# coding: utf-8\n",
        "# ",
        "",
        "",
        "python",
        "Main.py",
      ],
      'ruby': [
        "",
        "# ",
        "",
        "",
        "ruby",
        "Main.rb",
      ],
      'php': [
        "<?php\n",
        "// ",
        "",
        "?>\n",
        "php",
        "Main.php",
      ],
      'bash': [
        "",
        "# ",
        "",
        "echo \"XXXXXXXX\"\n",
        "sh",
        "Main.sh",
      ],
      'r': [
        "",
        "# ",
        "",
        "cat(\"XXXXXXXX\")\n",
        "r",
        "Main.R",
      ],
      'javascript': [
        "process.stdin.resume();\nprocess.stdin.setEncoding('utf8');\n",
        "// ",
        "",
        "",
        "javascript",
        "Main.js",
      ],
      'coffeescript': [
        "",
        "# ",
        "",
        "console.log(\"XXXXXXXX\")\n",
        "coffee",
        "Main.coffee",
      ],
      'mysql': [
        "create table Test(id integer, title varchar(100));\ninsert into Test(id, title) values(1, \"Hello\");\nselect * from Test;\n",
        "-- ",
        "",
        "",
        "sql",
        "Main.sql",
      ],
      'default': [
        "",
        "# ",
        "",
        "",
        "text",
        "Main.txt",
      ],
    };

    languages = [
      {id: "c", label: 'C'},
      {id: "cpp", label: 'C++'},
      {id: "objective-c", label: 'Objective-C'},
      {id: "java", label: "Java"},
      {id: "php", label: "PHP"},
      {id: "ruby", label: "Ruby"},
      {id: "python", label: "Python2"},
      {id: "python3", label: "Python3"},
      {id: "perl", label: "Perl"},
      {id: "scala", label: "Scala"},
      {id: "go", label: "Go"},
      {id: "csharp", label: "C#"},
      {id: "haskell", label: "Haskell"},
      {id: "clojure", label: "Clojure"},
      {id: "d", label: "D"},
      {id: "erlang", label: "Erlang"},
      {id: "r", label: "R"},
      {id: "javascript", label: "JavaScript"},
      {id: "coffeescript", label: "CoffeeScript"},
      {id: "cobol", label: "Cobol"},
      {id: "vb", label: "VB"},
      {id: "fsharp", label: "F#"},
      {id: "bash", label: "Bash"},
      {id: "mysql", label: "MySQL"},
    ];

    languageId2LavelMap = {};
    for (i = 0, len = languages.length; i < len; i++) {
      language = languages[i];
      languageId2LavelMap[language.id] = language.label;
    }
    Language = {
      langinfos: langinfos,
      getTemplate: (language, comments) => {
        let comment, j, langinfo, len1, template;
        langinfo = langinfos[language];
        template = langinfo[0];
        for (j = 0, len1 = comments.length; j < len1; j++) {
          comment = comments[j];
          template += langinfo[1] + comment + "\n";
        }
        template += langinfo[2] + "\n";
        template += langinfo[3];
        return template;
      },
      getLanguageFromFilename: function(filename) {
        let pos = filename.indexOf('.');
        if(pos === -1){
          return null;
        }
        let ext = filename.substr(pos + 1);

        for(let key in langinfos){
          let langinfo = langinfos[key];
          let mainfile = langinfo[5];
          let pos2 = mainfile.indexOf('.');
          let ext2 = mainfile.substr(pos2 + 1);
          if(ext2 === ext){
            return key;
          }
        }
        return null;
      },
      getMainFilename: (language) => {
        let langinfo = langinfos[language];
        return langinfo[5];
      },
      getPrefixTemplate: (language) => {
        let langinfo = langinfos[language];
        return langinfo[0];
      },
      getACEmode: (language) => {
        let langinfo = langinfos[language];
        return langinfo && langinfo[4];
      },
      getLanguages: () => {
        return languages;
      },
      getLabel: (language) => {
        let label;
        label = languageId2LavelMap[language];
        return label;
      },
    };
    return Language;
  });
